import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

export type MatchEntry = {
  userId: string;
  displayName: string;
  favoriteTeam: string | null;
  iGive: number;
  iGet: number;
  score: number;
};

export function useMatches(slug: string) {
  return useQuery({
    queryKey: ['matches', slug],
    queryFn: () => api<{ matches: MatchEntry[] }>(`/api/albums/${slug}/matches`).then((r) => r.matches),
    staleTime: 30_000,
  });
}

export type SwapSticker = { code: string; team: string | null; kind: string; position: number };
export type MatchDetail = {
  friend: { id: string; displayName: string; favoriteTeam: string | null };
  iGive: SwapSticker[];
  iGet: SwapSticker[];
  score: number;
};

export function useMatchDetail(slug: string, friendId: string) {
  return useQuery({
    queryKey: ['matches', slug, friendId],
    queryFn: () => api<MatchDetail>(`/api/albums/${slug}/matches/${friendId}`),
    staleTime: 30_000,
  });
}
